import React, { ChangeEvent, useState } from "react";

type FileInputProps = {
  id: string;
  label: string;
  className?: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const FileInput = ({
  id,
  label,
  onChange,
  className = "",
}: FileInputProps) => {
  const [fileName, setFileName] = useState<string | null>(null);

  function manageInputChange(e: ChangeEvent<HTMLInputElement>) {
    const file = e.target.files;

    if (file && file.length) {
      const [firstFile] = file;
      const { name, size } = firstFile;
      const fileSize = (size / 1000).toFixed(2);
      setFileName(`${name} - ${fileSize}KB`);
    }

    onChange(e);
  }

  const baseClassname = "file-input";
  return (
    <div className={`${baseClassname} ${className}`}>
      <input
        type="file"
        {...{ id }}
        className={`${baseClassname}__input`}
        onChange={(e) => manageInputChange(e)}
      />
      <label htmlFor={id} className={`${baseClassname}__label`}>
        <span>{label}</span>
        {fileName !== null && <span>{fileName}</span>}
      </label>
    </div>
  );
};
